var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#6FCD9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3654 8.23435C17.5154 8.38437 17.5997 8.58782 17.5997 8.79995C17.5997 9.01208 17.5154 9.21553 17.3654 9.36555L10.9654 15.7656C10.8154 15.9155 10.612 15.9998 10.3998 15.9998C10.1877 15.9998 9.98426 15.9155 9.83424 15.7656L6.63424 12.5656C6.48851 12.4147 6.40788 12.2126 6.4097 12.0028C6.41152 11.7931 6.49566 11.5924 6.64398 11.4441C6.79231 11.2958 6.99296 11.2116 7.20272 11.2098C7.41247 11.208 7.61456 11.2886 7.76544 11.4344L10.3998 14.0688L16.2342 8.23435C16.3843 8.08437 16.5877 8.00012 16.7998 8.00012C17.012 8.00012 17.2154 8.08437 17.3654 8.23435Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.fa6bd01c769a5f6d998bc229c3be501b.svg";
export { ForwardRef as ReactComponent };